import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import ScrollToTop from "./components/ScrollToTop";
import ScrollProgress from "./components/ScrollProgress";
import Index from "./pages/Index";
import { legacyRedirectRoutes } from "./components/LegacyRedirects";

// Lazy-load all non-home routes to keep the LCP bundle small.
const PowerPro = lazy(() => import("./pages/PowerPro"));
const UtilityFiling = lazy(() => import("./pages/UtilityFiling"));
const ReGreenExchange = lazy(() => import("./pages/ReGreenExchange"));
const ForDevelopers = lazy(() => import("./pages/ForDevelopers"));
const About = lazy(() => import("./pages/About"));
const IndependentMonitor = lazy(() => import("./pages/IndependentMonitor"));
const Security = lazy(() => import("./pages/Security"));
const Careers = lazy(() => import("./pages/Careers"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse"));
const Contact = lazy(() => import("./pages/Contact"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <MotionConfig reducedMotion="user">
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollProgress />
          <ScrollToTop />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/products/powerpro" element={<PowerPro />} />
              <Route path="/products/utilityfiling" element={<UtilityFiling />} />
              <Route path="/products/regreen" element={<ReGreenExchange />} />
              <Route path="/for-developers" element={<ForDevelopers />} />
              <Route path="/about" element={<About />} />
              <Route path="/services/independent-monitor" element={<IndependentMonitor />} />
              <Route path="/security" element={<Security />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              {legacyRedirectRoutes()}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </MotionConfig>
  </QueryClientProvider>
);

export default App;
